import React, { useEffect, useState } from 'react'
import {useNavigate,useLocation} from 'react-router-dom'
import baseUrl from "./BaseUrl";
import axios from 'axios';



const InactivityTimeout = ({children}) => {
    const [userActive,setUserActive] = useState(true)
    const navigate = useNavigate();
    const location = useLocation();
    let inactivityTimer;

    const isLoginPage = location.pathname === '/';

    useEffect(() => {
        const skipPaths = ['/set-password', '/forgot-password','/mfa'];
        const shouldSkip = skipPaths.some(skip => location.pathname.includes(skip));
        
        if(!shouldSkip){

            // Check inactivity before adding listeners
            const last = parseInt(localStorage.getItem("lastActive") || "0");
            const now = Date.now();
            const diffMinutes = (now - last) / (1000 * 60);
            

            if (diffMinutes > 60) {
                console.log("🚫 Inactive too long — logging out");
                Logout(); // User was inactive too long
                return; // Do not add event listeners or start timer
            }

        
            resetTimer(); //

            document.addEventListener("mousemove", resetTimer);
            document.addEventListener("keydown", resetTimer);
            document.addEventListener("click", resetTimer);


            return () => {
                document.removeEventListener("mousemove", resetTimer);
                document.removeEventListener("keydown", resetTimer);
                document.removeEventListener("click", resetTimer);
                clearTimeout(inactivityTimer);
            };
        }
    }, [location.pathname]);   


    const Logout = async () => {
        try {
            // setPopupOpen(true);
            await axios.delete(`${baseUrl}/logout`);
            navigate("/");
        } catch (error) {
            console.log(error);
            // setPopupOpen(false);
        }
    }

    const resetTimer = () => {
        localStorage.setItem("lastActive", Date.now().toString());
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(() =>  Logout(),  60 * 60 * 1000); // 1 hour
    };  


    const handleInactivityTimeout = async () => {
        setUserActive(false);
        await Logout()
        // alert('You have been inactive for 20 seconds. Logging out for security.');
      };

    // useEffect(()=>{
    //     let timeoutId;
        
    //     const handleActivity = () => {
    //         clearTimeout(timeoutId); // Clear the timeout whenever activity is detected
    //         setUserActive(true);
    //         timeoutId = setTimeout(handleInactivityTimeout, 2*60*60*1000);
    //     };
                

    //     if(!isLoginPage){
    //         timeoutId = setTimeout(handleInactivityTimeout, 2*60*60* 1000)
    //         // Add event listeners to track user activity
    //         document.addEventListener('mousemove', handleActivity);
    //         document.addEventListener('keypress', handleActivity);
    //     }
       

    //     return () => {
    //         // Cleanup event listeners on component unmount
    //         clearTimeout(timeoutId)
    //         document.removeEventListener('mousemove', handleActivity);
    //         document.removeEventListener('keypress', handleActivity);
    //     };    
    // },[location.pathname])

  return (
    <>{children}</>
  )
}

export default InactivityTimeout